import { Api } from "@/api";
import { AdminType, PaginationType, UserLoginType } from "@/DTO";
import { ConvertToAdminType } from "@/api/admin/get";
import { ConvertToPaginationType } from "@/api/help";

export const GetAdminList = (user: UserLoginType, pagination: PaginationType, phone?: string) => {
  return new Promise<{
    data: AdminType[]
    pagination: PaginationType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `admin`,
      params: {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        phone: phone
      },
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToAdminListType(data.data),
          pagination: ConvertToPaginationType(data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToAdminListType = (data: any[]): AdminType[] => {
  const returnData = data.map((item) => {
    return ConvertToAdminType(item);
  });
  return returnData;
};

